"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var comment_box_form_1 = require("../comment-box-form");
var ProbabilityForm = /** @class */ (function (_super) {
    __extends(ProbabilityForm, _super);
    function ProbabilityForm(msg) {
        var _this = _super.call(this) || this;
        _this.keysOrder = ['Define proof points in this phase', 'Phase Activities',
            'Reasons for Optimism', 'Reasons for Permission', 'Others'];
        _this.form = {
            'Define proof points in this phase': { comment: '', gridType: 'long' },
            'Phase Activities': { comment: '', gridType: 'long' },
            'Reasons for Optimism': { comment: '', gridType: 'long' },
            'Reasons for Permission': { comment: '', gridType: 'long' },
            'Others': { comment: '', gridType: 'long' }
        };
        _this.parseFormComments(msg);
        return _this;
    }
    return ProbabilityForm;
}(comment_box_form_1.CommentBoxForm));
exports.ProbabilityForm = ProbabilityForm;
//# sourceMappingURL=probability-form.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/input-screen/comment-box/probability-form/probability-form.js